module.exports = __webpack_public_path__ + "img/Löschfahrzeug.3e5a553d.svg";